import React from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import { Col, Row } from "react-bootstrap";
import ContentfulBlogs from "../../components/contentfulBlogs/ContentfulBlogs";
import { appServerSideProps } from "../../utils/getAppService";
import Utils from "../../utils/Utils";
import UpdatePlan from "../../components/update-plan/UpdatePlan";

const MarchMadnessTool = ({ user }) => {
  const isPayed = Utils.hasStandardPlan(user) || Utils.hasPremiumPlan(user);

  return (
    <MainLayout>
      {!isPayed ? (
        <div style={{ height: "100vh", position: "relative" }}>
          <div className="mt-1 modal-overlay update-plan">
            <UpdatePlan page="bracketBuilder" />
          </div>
        </div>
      ) : (
        <>
          <div style={{ backgroundColor: "#F8F8FF", msOverflowX: "hidden" }}>
            <div className="box col-md-12 text-md-left ValueBracketTitle" style={{ backgroundColor: "#F8F8FF" }}>
              <Row
                style={{
                  justifyContent: "flex-start",
                  paddingTop: "70px",
                  paddingBottom: "20px",
                  paddingLeft: "20px",
                }}
              >
                <Col md={12} lg={7} xl={7} xxl={7}>
                  <h1>ShotQuality Bracket Builder</h1>
                </Col>
              </Row>
              <Row
                style={{
                  justifyContent: "flex-start",
                  paddingLeft: "20px",
                }}
              >
                <Col md={12} lg={7} xl={7} xxl={7}>
                  <p>
                    Access cutting-edge predictive analytics to power your March Madness picks. Our first-of-its-kind
                    dataset of over 50 million data points accounts for every shot taken by every player and every team.
                  </p>
                </Col>
              </Row>
            </div>
            <iframe
              title="March Madness Tool"
              // src={"https://shotquality.shinyapps.io/march_madness/"}
              src={"https://sq-shiny.shinyapps.io/march_madness/"}
              style={{
                width: "100%",
                paddingTop: "50px",
                height: "1200px",
                border: "0",
                boxShadow: "none",
                paddingBottom: "100px",
              }}
            />
          </div>
          <div className="container">
            <ContentfulBlogs user={user} tag="marchMadness" />
          </div>
        </>
      )}
    </MainLayout>
  );
};

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  const isUserLogged = appService.getUser();
  let user = null;
  if (isUserLogged) {
    user = await appService.get("api/account");
  }

  return {
    props: {
      user,
    },
  };
});

export default MarchMadnessTool;
